/**
 * ============================================================
 * mediaPaths.js — builds paths for media files
 * ============================================================
 *
 * These utilities turn filenames from the database into
 * frontend URLs, with fallbacks for missing files.
 *
 * All uploads are stored in /public/assets/... on the server.
 * Express exposes them at:
 *   /people-photos/*
 *   /project-photos/*
 *   /publication-pdfs/*
 *
 * These helpers ensure the frontend always builds correct URLs.
 **/

// Backend origin is dynamic based on environment
// Local dev:  http://localhost:8080
// Production: https://synlab.ca
const BACKEND_ORIGIN =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";

// ------------------------------------------------------------
// Person photo path with fallback to default
// ------------------------------------------------------------
export function personPhoto(filename) {
  if (!filename || filename === "null") {
    return `/images/default-person.png`; // served by frontend build
  }
  return `${BACKEND_ORIGIN}/people-photos/${filename}`;
}

// ------------------------------------------------------------
// Project photo path with fallback to default
// ------------------------------------------------------------
export function projectPhoto(filename) {
  if (!filename || filename === "null") {
    return `/images/default-project.jpg`;
  }
  return `${BACKEND_ORIGIN}/project-photos/${filename}`;
}

// ------------------------------------------------------------
// Publication PDF path or null
// ------------------------------------------------------------
export function pubPdf(filename) {
  if (!filename || filename === "null") {
    return null;
  }
  return `${BACKEND_ORIGIN}/publication-pdfs/${filename}`;
}